/// <reference types="google.maps" />
import { assignSafe } from '@summit/core';
import { EPosition } from '@summit/models';
export class SMapMarker {
  title: string;
  label: string;
  info: string;
  icon: string | google.maps.Symbol;
  point: EPosition;

  constructor(jsonData?: Partial<SMapMarker>) {
    //Normal
    if (jsonData) {
      assignSafe(this, jsonData);
      if (jsonData.point) {
        this.point = new EPosition(jsonData.point);
      }
    }
  }

  getOptions(): google.maps.MarkerOptions {
    const response: google.maps.MarkerOptions = {};
    if (this.icon) {
      response.icon = this.icon;
    }
    return response;
  }

  getGooglePoint(): any {
    console.log('point', this.point);
    return {
      lat: this.point?.latitude,
      lng: this.point?.longitude
    };
  }
}
